'use client';

import { c as _c } from "react/compiler-runtime";
import { ReceiverTypes } from 'api-graphql-types/enums';
import { isNussbaum } from 'product-analytics';
import MatchingEventsBanner_ from './MatchingEventBanners';
import { ApiRouteNames, useApi } from '@/api';
import { useLocale } from '@/i18n/client';
type MatchingEventsBannerProps = {
  receiverType: ReceiverTypes;
  receiverId: string | number;
  className?: string;
};
function Banners(t0) {
  const $ = _c(7);
  const {
    receiverId,
    className
  } = t0;
  const locale = useLocale();
  const isNussbaumVersion = isNussbaum(receiverId);
  const t1 = String(receiverId);
  const t2 = isNussbaumVersion ? "true" : "";
  let t3;
  if ($[0] !== locale || $[1] !== t1 || $[2] !== t2) {
    t3 = {
      slug: t1,
      locale,
      isNussbaumVersion: t2
    };
    $[0] = locale;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data
  } = useApi(ApiRouteNames.apiMatchingEventsProjects, t3);
  if (!data) {
    return null;
  }
  let t4;
  if ($[4] !== className || $[5] !== data) {
    t4 = <MatchingEventsBanner_ matchingEvents={data} className={className} />;
    $[4] = className;
    $[5] = data;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function MatchingEventsBanner(t0) {
  const $ = _c(5);
  let props;
  let receiverType;
  if ($[0] !== t0) {
    ({
      receiverType,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = receiverType;
  } else {
    props = $[1];
    receiverType = $[2];
  }
  if (receiverType !== ReceiverTypes.Project) {
    return null;
  }
  let t1;
  if ($[3] !== props) {
    t1 = <Banners {...props} />;
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export default MatchingEventsBanner;